import React, { useMemo } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { GET_REWARDS_CARDS_PACKS, REWARD_CARD_PACK_STASTS } from '../services/graphql';
import styles from './RewardCardPacks.module.scss'
import { ProgressBar } from '@squirrellearningltd/go-pupil-components';
import { navigate } from '@reach/router';

const RewardCardPacks = ({ setSelectedPack, sortOrder }) => {
    const { data, error, loading } = useQuery(GET_REWARDS_CARDS_PACKS);
    const { data: packStatsData, error: packStatsError, loading: packStasLoading } = useQuery(REWARD_CARD_PACK_STASTS,
        {
            skip: !data
        }
    )

    const sortedPacks = useMemo(() => {
        if (!data?.rewardCardPacks) return [];

        return [...data.rewardCardPacks].sort((a, b) => {
            const dateA = new Date(a.createdAt.replace(' ', 'T').replace(' UTC', 'Z'));
            const dateB = new Date(b.createdAt.replace(' ', 'T').replace(' UTC', 'Z'));

            return sortOrder === 'desc'
                ? dateB - dateA
                : dateA - dateB;
        });
    }, [data, sortOrder]);

    const getPackStatsById = (packId) => {
        return packStatsData?.currentStudent?.rewardCardPackStats.find(packStatData => packStatData.id === packId)
    }

    if (loading) {
        return <p>Loading...</p>
    }

    if (error) {
        return <p>{error.message}</p>
    }

    return <>
        {
            sortedPacks.length ?
                <div className={styles.rewardCardPacksContainer}>
                    {sortedPacks.map((rewardCardPack) =>
                        <div
                            key={rewardCardPack.id}
                            to={`rewardCardPack/${rewardCardPack.name}`}
                            onClick={() => {
                                setSelectedPack(rewardCardPack);
                                navigate(`/rewards/rewardCardPack/${rewardCardPack.id}`);
                            }}
                        >
                            <div
                                className={styles.rewardCardsPack}>
                                <h3 className={styles.rewardCardsPackTitle}>{rewardCardPack.name}</h3>
                                <div className={styles.rewardCardsPackCoverUrl}>
                                    {
                                        rewardCardPack.previewImageUrl ?
                                            <img
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover'
                                                }}
                                                src={rewardCardPack.previewImageUrl} alt='' /> :
                                            <div style={{ backgroundColor: '#C4C4C4', height: '100%' }}></div>
                                    }
                                </div>

                                {
                                    packStasLoading ?
                                        <p>Loading...</p> :
                                        packStatsData ?
                                            <div className={styles.rewardCardsPackUnlockedPercentage}>
                                                <p className={styles.rewardCardsPackUnlockedPercentageTitle}>{getPackStatsById(rewardCardPack.id)?.collected_cards} / {getPackStatsById(rewardCardPack.id).total_cards} Cards unlocked</p>
                                                <ProgressBar progress={
                                                    getPackStatsById(rewardCardPack.id).total_cards > 0 ?
                                                        Math.round((getPackStatsById(rewardCardPack.id)?.collected_cards / getPackStatsById(rewardCardPack.id).total_cards) * 100) :
                                                        0
                                                }
                                                    backgroundColor='#7D9826'
                                                />
                                            </div> :
                                            <p>{packStatsError.message}</p>}
                            </div>
                        </div>
                    )}
                </div> :
                <p>No card packs available</p>
        }

    </>
}

export default RewardCardPacks
